import { render, staticRenderFns } from "./App.vue?vue&type=template&id=fb2705be&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=fb2705be&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=fb2705be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2705be",
  null
  
)

export default component.exports